import { render, staticRenderFns } from "./circulation-distribute-case.vue?vue&type=template&id=33dd3351&scoped=true"
import script from "./circulation-distribute-case.vue?vue&type=script&lang=ts"
export * from "./circulation-distribute-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dd3351",
  null
  
)

export default component.exports